/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DraftUIRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_draft_ui.pb'
import {DraftUIResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/cash_draft_ui.pb'


export const generateDraftUI = (request: DraftUIRequest, options?: CashRequestOptions) => post<DraftUIRequest, DraftUIResponse>("/2.0/cash/generate-draft-u-i", request, {...options, rejectOnError: true })